var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({attrs:{"rules":_vm.allRules,"counter":_vm.computedCounter,"label":_vm.$t(_vm.label)},on:{"input":_vm.handleInput},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }